module.exports = __webpack_public_path__ + "img/noviceattender-locked.f9ea1c29.png";